import {useEffect} from 'react';

import {RouteName} from 'config/navigation';
import {Breakpoints} from 'styles/Base';

const PRELOADED_PREFIX = 'preloaded-';

export const useImagePreloader = (img: string, route: RouteName, breakpoint?: Breakpoints) => {
  useEffect(() => {
    const preloadedId = `${PRELOADED_PREFIX}${img}`;
    if (!document.getElementById(preloadedId) && window.location.pathname === `/customers${route}`) {
      const mediaQueryList = breakpoint && window.matchMedia(`(${breakpoint})`);
      if (mediaQueryList && mediaQueryList.matches) {
        return;
      }
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = img;
      link.as = 'image';
      link.id = preloadedId;
      document.head.appendChild(link);
    }
  }, [img, route, breakpoint]);
  return null;
};
